// extracted by mini-css-extract-plugin
module.exports = {"Active":"AppRouter_Active__kouyA"};